// Selects the vertical space (in px) consumed by surrounding chrome above/below
// the table body when the table fills the screen. The right amount depends on the
// surrounding layout, so each variant maps to a fixed offset below.
export enum FitHeightOffset {
  // Standard fullscreen table.
  Default = 'default',
  // Table with an extra actions / nested-header row that consumes vertical space.
  Actions = 'actions',
  // Table embedded in a widget with surrounding title/actions.
  Widget = 'widget',
}

const OFFSET_PX: Record<FitHeightOffset, number> = {
  [FitHeightOffset.Default]: 265,
  [FitHeightOffset.Actions]: 330,
  [FitHeightOffset.Widget]: 420,
};

// Floor so the body never collapses to an unusable height on short viewports.
const MIN_HEIGHT_PX = 250;

export function getFitHeightStructure<T extends { bodyMaxHeight?: string | number } | undefined>(
  structure: T,
  fitHeight: FitHeightOffset | undefined
): T {
  if (!fitHeight) {
    return structure;
  }

  return { ...structure, bodyMaxHeight: `max(calc(100vh - ${OFFSET_PX[fitHeight]}px), ${MIN_HEIGHT_PX}px)` };
}
